import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {Location} from '@angular/common';
import {ConfigService} from '../service/config.service';
import {Router} from '@angular/router';
declare var ga: Function;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector, private configService: ConfigService) {
  }

  handleError(error) {
    const router = this.injector.get(Router);
    const location = this.injector.get(Location);

    const gaTrackingID = this.configService.getGATrackingID();
    ga('create', gaTrackingID, 'auto');
    console.log('Initiated GA Tracking ID: ' + gaTrackingID)

    ga('set', 'page', location.path());
    ga('send', {
      hitType: 'event',
      eventCategory: 'donation-form',
      eventAction: 'error',
      eventLabel: 'router.url: ' + /*router.url + */ ' error:' + error.message,
      eventValue: error.stackTrace}
      );

    console.error('An error occured on url: ' + /*location.path() +*/ ' error:' + error.message)
    console.error('error: ' + error);
  }
}
